export const ProcessCarouselConfig = [
    { span: 24, height: "40px", classes: "marginTop-16" },
    {
        classes: "marginTop-16 flex",
        columns: [
            { height: "220px", span: 4 },
            { height: "220px", span: 4 },
            { height: "220px", span: 4 },
            { height: "220px", span: 4 },
            { height: "220px", span: 4 },
            { height: "220px", span: 4 },
        ],
    },
]
